import React, { useState , useEffect ,useContext } from 'react';
import confetti from 'canvas-confetti';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faIndianRupeeSign  } from '@fortawesome/free-solid-svg-icons';
// import PhoneInput from 'react-phone-input-2';
// import '../royal.css';
// import { CurrencyContext } from "./CurrencyContext";
import { CountryContext } from './CountryContext';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import emailjs from 'emailjs-com';

const countryoffer = {
  US: { icon: '$', value: '115' },
  IN: { icon: '₹', value: '10,000' },
  SG: { icon: 'S$', value: '150' },
};


const ContactForm = () => {

//  const currency = useContext(CurrencyContext);
 const country = useContext(CountryContext);

const offer = countryoffer[country.countryCode] || countryoffer["US"];

 const countryname = country.countryName;

const [gclid, setGclid] = useState('');
 
   const [utmParams, setUtmParams] = useState({
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_term: '',
    utm_content: ''
  });

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    dialCode: "",
    nationalNumber: "",
    leadsource: "SignUp-Int2Cruises",
    country:"" ,
    utm_source: "",
    utm_medium: "",
    utm_campaign:"" ,
    utm_term:"",
    utm_content: "",
    zc_gad: ""
  });


  useEffect(() => {
  if (countryname) {
    setFormData(prev => ({ ...prev, country: countryname }));
  }
}, [countryname]);



const [showPopup, setShowPopup] = useState(false);  
const [loading, setLoading] = useState(false);  


useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const utm= {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_term: params.get('utm_term') || '',
      utm_content: params.get('utm_content') || ''
    };
    
    const gclidValue = params.get('gclid') || '';
    setUtmParams(utm);
    setGclid(gclidValue);

   setFormData((prevData) => ({
    ...prevData,
    ...utm,
    zc_gad: gclidValue
  }));

  }, [gclid]);
  

  useEffect(() => {
  if (showPopup) {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 }
    });
  }
}, [showPopup]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData();
    for (const key in formData) {
      form.append(key, formData[key]);
    }

    setLoading(true);  

    try {
      const response = await fetch("https://script.google.com/macros/s/AKfycbyK0i_OSXB6J6bcQc6J4gLGHo6WjXACPOjVdCuxA32eCd6m7jyC-CJTkJkKOebPEMWzdg/exec", {
        method: "POST",
        body: form
      });

      await emailjs.send(
      'service_gkjf62i',
      'template_vpk0vd6',
      {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        mobile: formData.mobile,
        dialCode: formData.dialCode,
        nationalNumber: formData.nationalNumber,
        country: formData.country,
        leadsource: formData.leadsource, 
        utm_source: formData.utm_source,
        utm_medium: formData.utm_medium,
        utm_campaign: formData.utm_campaign,
        utm_term: formData.utm_term,
        utm_content: formData.utm_content,
        zc_gad:  formData.zc_gad
      },
      'eg06L6EKyPge0oB5Y'
    );

 
      if (response.ok) {
        localStorage.setItem('formSubmitted', 'true');
        setShowPopup(true); 
      } else {
        alert("There was an error submitting the form.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form!");
    } finally {
      setLoading(false); 
    }
  };

  return (
    <div>
      <div className="cform-container">
        <form onSubmit={handleSubmit} className="form-box">
          {/* <h2 className="form-title">REQUEST A AZAMARA QUOTE</h2> */}
      <center> <h2  id="staticBackdropLabel">Sign up and get</h2></center>
      <center> <h1  id="staticBackdropLabel">UPTO &nbsp;
         {offer.icon}
         {offer.value}&nbsp;OFF</h1>
        </center>
      <center> <p>On Your Bookings</p></center>

       <div className='align  formstart '>
          <div className="form-group">
            <label>First Name *</label>
            <input
              type="text"
              name="firstName"
              onChange={handleChange}
              placeholder="First Name"
              required
            />
          </div>

          <div className="form-group">
            <label>Last Name *</label>
            <input
              type="text"
              name="lastName"
              onChange={handleChange}
              placeholder="Last Name"
              required
            />

            </div>

            </div>
      

  <div className='align mobile-align'>
          <div className="form-group emailorder">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              onChange={handleChange}
              placeholder="Email"
              required
            />
          </div>

          <div className="form-group phoneorder">
            <label>Phone *</label>
            {/* <input
              type="tel"
              name="mobile"
              onChange={handleChange}
              placeholder='Phone'
              required
            /> */}
              <PhoneInput
      international
      defaultCountry={country.countryCode}
      // value={value}
      // onChange={setValue}
      value={formData.mobile}
      onChange={(phone) => {
        //  const cleaned = phone.replace(/\s|-/g, '');
const parsed = parsePhoneNumberFromString(phone || '');

  // Match +[1 to 4 digit dial code] followed by 6 to 14 digits of national number
  // const match = cleaned.match(/^(\+\d{1,4})(\d{6,14})$/);
      // const match = phone.match(/^(\+\d{1,4})(\d{6,15})$/); // splits +code and number
      // const dialCode = match?.[1] || '';
      // const nationalNumber = match?.[2] || '';
        if (parsed && parsed.countryCallingCode && parsed.nationalNumber) {
    setFormData(prev => ({
      ...prev,
      mobile: phone,
      dialCode: '+' + parsed.countryCallingCode,
      nationalNumber: parsed.nationalNumber
    }));
  }}}
      placeholder="enter your phone"
      className='phoneinput'
   
   />
            
          </div>
   </div>

          {/* <div className="form-group">
            <label>Number of Travellers</label>
            <input
              type="number"
              name="passengers"
              onChange={handleChange}
              placeholder="Number of Travellers"
            />
          </div> */}

          
  {/* <div className='align'>

          <div className="form-group travel">
            <label>Travel Month</label>
            <input
              type="date"
              name="monthOfTravel"
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Destination *</label>
            <input
              type="text"
              name="destination"
              onChange={handleChange}
              placeholder="Destination"
              required
            />
          </div>
</div> */}

      {/* <div className="form-group">
   <label htmlFor="message">Message</label>
   <textarea
     id="message"
    name="message"
    placeholder="Your message here..."
    rows="4"
    value={formData.message}
    onChange={handleChange}
   ></textarea>
 </div> */}


 {/* Hidden UTM Fields */}
 <input type="hidden" name="utm_source" value={utmParams.utm_source} />
 <input type="hidden" name="utm_medium" value={utmParams.utm_medium} />
 <input type="hidden" name="utm_campaign" value={utmParams.utm_campaign} />
 <input type="hidden" name="utm_term" value={utmParams.utm_term} />
 <input type="hidden" name="utm_content" value={utmParams.utm_content} />
 <input type="hidden" id="zc_gad" name="zc_gad" value="" />
          

          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>
      </div>

      {/* Popup Animation */}
      {showPopup && (
        <div className="popup-container celebration">
          <div className="popup-content">
                <div className="confetti"></div> {/* Confetti animation */}
            <h3>🎉 Thank you!</h3>
            <p>Your <strong>Exclusive Promo Code</strong> has been sent to your registered email.</p>
            <p>Get Ready to Set Sail With Amazing Savings!</p>
            <button onClick={() => setShowPopup(false)} className="close-popup">Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactForm;
